
















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PurchasedItem, PurchasedItemType } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { $t } from "@/lib/i18nHelpers";
import AttachmentsInfo from "@/components/AttachmentsInfo";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "PurchasedItemBase",
  components: { BaseIcon, AttachmentsInfo },
  props: {
    item: { type: Object as PropType<PurchasedItem>, required: true },
    wrapperClass: { type: String },
  },
  setup(props) {
    const type = computed(() => props.item.subject.subjectType);

    const isTextPost = computed(() => type.value === PurchasedItemType.RICH_TEXT_POST);

    const headerText = computed(() => {
      switch (type.value) {
        case PurchasedItemType.MEDIA_POST:
          return $t("Media post");
        case PurchasedItemType.MESSAGE_ATTACHMENT:
          return $t("Paid message");
        case PurchasedItemType.RICH_TEXT_POST:
          return $t("Text post");
      }
    });

    const icon = computed(() => (isTextPost.value ? "sci-text-post" : "sci-file-multiple"));

    return { headerText, icon, isTextPost };
  },
});
